
import React from 'react';
import { EnhancedCrawlResult } from '@/types/crawler';
import DashboardOverview from '@/components/dashboard/DashboardOverview';
import DashboardWidgetContainer from '@/components/dashboard/widgets/DashboardWidgetContainer';
import { DashboardWidgetRefs, RetryHandlers } from '@/components/dashboard/types';

interface ResultsContentProps {
  crawlResult: EnhancedCrawlResult;
  onNewCrawl: () => void;
  onNavigate: (page: string) => void;
  selectedPageUrl: string | null;
  widgetRefs: DashboardWidgetRefs;
  onSelectPage: (url: string) => void;
  retryHandlers: RetryHandlers;
}

const ResultsContent: React.FC<ResultsContentProps> = ({
  crawlResult,
  onNewCrawl,
  onNavigate,
  selectedPageUrl,
  widgetRefs,
  onSelectPage,
  retryHandlers
}) => {
  return (
    <div className="max-w-6xl mx-auto pt-8 space-y-12" data-testid="dashboard-results-container">
      <div ref={widgetRefs.dashboard} data-testid="dashboard-overview-section">
        <DashboardOverview 
          crawlResult={crawlResult}
          onNewCrawl={onNewCrawl}
          onNavigate={onNavigate}
          onSelectPage={onSelectPage}
        />
      </div>
      
      <DashboardWidgetContainer
        crawlResult={crawlResult}
        selectedPageUrl={selectedPageUrl}
        widgetRefs={widgetRefs}
        onSelectPage={onSelectPage}
        retryHandlers={retryHandlers}
      />
      
      {/* Removed any potential Top Performing Pages section that might be rendered here */}
    </div>
  );
};

export default ResultsContent;
